import { DateTime } from 'luxon';

export const checkIsBeforeEarliestCheckinTime = (
  earliestCheckinDate?: DateTime,
  date?: DateTime
) => {
  if (!earliestCheckinDate) return false;
  if (
    earliestCheckinDate?.hasSame(
      earliestCheckinDate?.startOf('day'),
      'millisecond'
    )
  )
    return false;

  if (!date) {
    const now = DateTime.now();

    return now.hasSame(earliestCheckinDate, 'day') && now < earliestCheckinDate;
  }

  const time = date.hour * 60 + date.minute;
  const earliestCheckinTime =
    earliestCheckinDate.hour * 60 + earliestCheckinDate.minute;

  return time && time < earliestCheckinTime;
};

export const getEearliestCheckinTime = (
  // backend returns `kommtGehtMinimaleStartZeit` in minutes
  kommtGehtMinimaleStartZeit = 0,
  date?: DateTime
) => {
  const currentDate = date ? date : DateTime.now();

  return currentDate.set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: kommtGehtMinimaleStartZeit * 60000,
  });
};
